import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
// Core components
import Card from 'components/core/Card';
// Models
import mParking from 'models/cpm/parking';
// Custom
import { cpmParkingDataShape, errorShape } from 'constants/PropTypesShapes';
import { sanitizeInt } from 'utils/Tools';
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import FormHelper from 'components/misc/FormHelper';
import NumberInputField from 'components/inputFields/NumberInputField';

class ParkingEditOccupancyForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: {
        insideQuantity, outsideQuantity, outsideQuantityPermanentExit,
      },
      parking, onValidate,
    } = this.props;

    onValidate(mParking.serializeState({
      insideQuantity,
      outsideQuantity,
      outsideQuantityPermanentExit,
    }), parking);
    return true;
  }

  render() {
    const {
      parking, fields: { insideQuantity, outsideQuantity, outsideQuantityPermanentExit }, errors,
      onFieldsChange,
    } = this.props;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <div className="d-flex">
              <FormHelper
                elements={[
                  {
                    content: <LocalizedMessage id="help.parkingOccupancy.formState" values={{ type: parking.type, origin: '' }} />,
                  },
                ]}
              />
              <div style={{ flex: 1 }}>
                <Card>
                  <div className="row">
                    <div className="col-12 col-lg-6">
                      <NumberInputField
                        label={<LocalizedMessage id="field.insideVehicles" />}
                        errorText={_get(errors, 'insideQuantity')}
                        min={0}
                        value={insideQuantity}
                        required
                        sanitizer={sanitizeInt}
                        inputMaxWidth={70}
                        onChange={(value) => onFieldsChange({ insideQuantity: value })}
                      />
                    </div>
                    <div className="col-12 col-lg-6">
                      <NumberInputField
                        label={<LocalizedMessage id="field.outsideVehicles" />}
                        errorText={_get(errors, 'outsideQuantity')}
                        min={0}
                        value={outsideQuantity}
                        required
                        sanitizer={sanitizeInt}
                        inputMaxWidth={70}
                        onChange={(value) => onFieldsChange({ outsideQuantity: value })}
                      />
                    </div>
                    {parking.restrictedByPermanentExit && (
                      <div className="col-12">
                        <NumberInputField
                          label={<LocalizedMessage id="field.permanentExitVehicles" />}
                          errorText={_get(errors, 'outsideQuantityPermanentExit')}
                          min={0}
                          value={outsideQuantityPermanentExit}
                          required
                          sanitizer={sanitizeInt}
                          inputMaxWidth={70}
                          onChange={(value) => onFieldsChange({ outsideQuantityPermanentExit: value })}
                        />
                      </div>
                    )}
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </FormDialogTemplate>

    );
  }
}

ParkingEditOccupancyForm.propTypes = {
  parking: cpmParkingDataShape.isRequired,
  operationError: errorShape, // eslint-disable-line react/no-unused-prop-types
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

ParkingEditOccupancyForm.defaultProps = {
  operationError: null,
  errors: null,
};

const mapFieldsToProps = {
  insideQuantity: {
    resourceKey: 'state.insideQuantity',
    defaultValue: 0,
  },
  outsideQuantity: {
    resourceKey: 'state.outsideQuantity',
    defaultValue: 0,
  },
  outsideQuantityPermanentExit: {
    resourceKey: 'state.outsideQuantityPermanentExit',
    defaultValue: 0,
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps.parking,
  operationError: ownProps.operationError,
});

const mapStateToProps = (state) => ({
  operationError: state.cpmCarparkParking.update.error,
});

module.exports = compose(
  connect(
    mapStateToProps,
  ),
  withFormManagement(
    mapFieldsToProps,
    mapOwnPropsToResources,
    false,
  ),
)(ParkingEditOccupancyForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkings/ParkingEditOccupancyForm.js